import { colors, HStack, useResponsive } from "goi_common";
import React, { ReactNode } from "react";

export default function EmojiShadowBox({ emoji, text }: { emoji: ReactNode; text: ReactNode }) {
  const { isBiggerThanLg } = useResponsive();
  return (
    <HStack
      gap={isBiggerThanLg ? 8 : 6}
      padding="10px 16px"
      background={colors.white}
      css={{ boxShadow: "0px 0px 10px rgba(46, 59, 67, 0.06)", flexShrink: 0 }}
      alignItems="center"
      width="fit-content"
      borderRadius="5px"
    >
      <div
        css={{ width: isBiggerThanLg ? "28px" : "20px", height: isBiggerThanLg ? "28px" : "20px" }}
      >
        {emoji}
      </div>
      <div>{text}</div>
    </HStack>
  );
}
